import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import {ApiConfigService} from 'frontier/nucleus';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AuthenticationService} from '../authentication.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'kpi4me-keycloak-redirect',
  templateUrl: './keycloak-redirect.component.html',
  styleUrls: ['./keycloak-redirect.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [MatProgressSpinner],
})
export class KeycloakRedirectComponent implements OnDestroy {
  subs: Subscription = new Subscription();

  constructor(
    private apiConfig: ApiConfigService,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router,
  ) {
    this.subs.add(
      route.queryParams.pipe(
        tap((params: Params): void => {
          const {callbackurl, refreshtoken}: { callbackurl: string; refreshtoken: string }
            = params as { callbackurl: string; refreshtoken: string };
          const separatorIdx: number = callbackurl.indexOf('?');
          const callbackUrl: string = separatorIdx === -1 ? callbackurl : callbackurl.slice(0, separatorIdx);
          const query: string = separatorIdx === -1 ? '' : callbackurl.slice(separatorIdx + 1);
          // Backend sends the token either bare (`?<jwt>`) or as a query param (`?accesstoken=<jwt>`);
          // take the param value when present so the JWT is stored without the `accesstoken=` prefix.
          const accessToken: string = new URLSearchParams(query).get('accesstoken') ?? query;
          authService.storeBearerToken(accessToken, refreshtoken);
          router.navigate([callbackUrl]);
        })
      ).subscribe()
    )
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
